let cellPadding = 0 // .cell 的 padding 值
export default class {
  doTableCol(arrs){  //TODO  这里需要优化写法  递归执行  现在没空
    arrs.forEach((ites)=>{
      if(ites.children&&ites.children.length){
        this.methods('doTableCol',ites.children)
      }else{
        this.mergeList.push(ites)
      }
    })
  }
  formatEmpty (value) {
    if (typeof value === 'number') {
      return value
    } else {
      return value || '— —'
    }
  }
  // 获取字段名
  setPropToLabelObj () {
    this.propToLabelObj = {}
    this.tableProp.forEach(item => {
      this.propToLabelObj[item.prop] = item
    })
  }
  // 计算每一列的宽度，并绑定到propToLabel上
  getPropToLabel () {
    let tableProp = this.tableProp
    let minWidth = []
    // 还有一些直接写在slot的minWidth中
    let slotWidth = 0
    if (this.$slots) {
      for (let key in this.$slots) {
        this.$slots[key].forEach(item => {
          if (item.componentOptions && item.componentOptions.propsData && item.componentOptions.propsData.minWidth) {
            slotWidth += +item.componentOptions.propsData.minWidth
          }
        })
      }
    }
    let len = tableProp.length
    tableProp.forEach((item, index) => {
      item.minWidth = item.width || this.methods('minWidth', item.prop)
      minWidth[0] = minWidth[0] || 0
      minWidth[0] += item.minWidth
      // 自动的隐藏等级
      minWidth[len - index] = minWidth[len - index] || 0
      minWidth[len - index] += item.minWidth
      // 自定义的隐藏等级
      // if (item.hideLevel) {
      //     minWidth[item.hideLevel] = minWidth[item.hideLevel] || 0
      //     minWidth[item.hideLevel] += item.minWidth
      // }
    })
    let newMinWidth = []
    minWidth.map((item, index) => {
      if (index > 0) {
        newMinWidth[index] = newMinWidth[index - 1] - item
      } else {
        newMinWidth[index] = item + slotWidth
      }
    })
    this.minWidthNum = newMinWidth
    return tableProp
  }
  /**
   * 自适应函数
   */
  autoExpand () {
    let tableWidth
    try {
      // 这里有个毛病，当这个表格不可见的时候，获取到的宽度是错的
      // 那么这里判断不可见就直接return了，也并不能完全解决问题
      // 所以在点击tabs切换的时候（表格从不可见变为可见），重新触发一次
      if (!$(this.$refs.table.$el).is(':visible')) {
        return
      }
      tableWidth = $(this.$refs.table.$el).width()
    } catch (e) {
      // console.log('暂时无法获取表格宽度')
    }
    if (!tableWidth) return
    this.hideLevel = []
    this.minWidthNum.forEach((item, index) => {
      if (tableWidth < item + 50) { // +50是后来微调的，为了彻底避免出现横向滚动条
        if (index === this.minWidthNum.length - 1) { // 如果已经到达最大等级，那么允许出现横向滚动条
          $(this.$refs.TTable).find('.el-table__body-wrapper').css('overflow-x', 'auto')
        }
        this.hideLevel.push(index + 1)
      }
    })
  }
  /**
   * 计算某一列的最小宽度
   * @param prop 列名
   */
  minWidth (prop) {
    if (!this.propToLabelObj[prop]) {
      return 0
    }
    let minWidth = 0
    if (this.propToLabelObj[prop].minWidth) {
      minWidth = this.propToLabelObj[prop].minWidth
    } else {
      let propWidth = this.methods('strWidth', this.propToLabelObj[prop].label, 1, prop === 'order' ? 0 : 0)
      // 当然得考虑formatter的情况
      let formatter = this.propToLabelObj[prop].formatter
      this.tableData && this.tableData.forEach(item => {
        let str = item[prop] || ''
        if (formatter) {
          str = formatter(item) || ''
        }
        let contentWidth = this.methods('strWidth', str.toString(), 0, prop === 'order' ? 0 : 0)
        let width = contentWidth > propWidth ? contentWidth : propWidth
        if (width > minWidth) {
          minWidth = width
        }
      })
      // 如果有额外的加成那么
      if (this.propToLabelObj[prop].add) {
        minWidth += this.propToLabelObj[prop].add
      }
      if (minWidth > 400) {
        minWidth = 400
      } else if (minWidth < 70) {
        minWidth = 70
      }
    }
    return minWidth // +15是因为排序按钮宽15像素
  }
  /**
   * 计算字符串的宽度
   * @param str 字符串
   * @param plus 在14号字体的基础上加多少
   * @param min 最少是多少
   * @returns {number} 宽度
   */
  strWidth (str, plus = 0, min = 0) {
    if (!str) return 0
    let all = str.length
    if (!str.match) {
      return 0
    }
    this.strWidthCellPadding = this.strWidthCellPadding || cellPadding || this.methods('getCellPadding')
    let chinese = (str.match(/[\u4E00-\u9FA5\uF900-\uFA2D|WM（）CPUSN]/g) || '').length
    let width = chinese * (15 + plus) + (all - chinese) * (8 + plus) + this.strWidthCellPadding * 2 // .cell的padding值的两倍
    return width > min ? width : min
  }
  getCellPadding () {
    let div = document.createElement('div')
    div.className = 'el-table'
    div.innerHTML = `<div class="cell"></div>`
    document.body.appendChild(div)
    cellPadding = parseInt($(div.querySelector('.cell')).css('padding-left'))
    $(div).remove()
    return cellPadding
  }
  /**
   * 点击某一行，转发element-ui的接口给父组件用
   * @param row 行数据
   * @param event 点击事件对象
   * @param column 列数据
   */
  clickTr (row, event, column) {
    // 如果并不需要记录选中，那么直接返回给父级即可
    if (!this.currentSelectedData) {
      this.$emit('row-click', ...arguments)
      return
    }
    let tr = event.target
    if (tr.tagName !== 'TR') {
      tr = $(tr).parents('tr').eq(0)[0]
    }
    // let tr = event.path.find(elem => elem.tagName === 'TR')
    if (!tr) return
    // 按住 ctrl 键的时候点击变黄色
    if (event.ctrlKey) {
      // 如果不是当前蓝色高亮的数据
      if (tr.className.indexOf('current-row') < 0) {
        let select = this.currentSelectedData.find(o => o === row)
        let selectIndex = select && this.currentSelectedData.indexOf(select)
        // 如果不是当前黄色高亮的数据
        if (tr.className.indexOf('selected-row') < 0) {
          this.currentSelectedData.push(row)
          $(tr).addClass('selected-row')
        } else {
          if (selectIndex !== undefined) {
            this.currentSelectedData.splice(selectIndex, 1)
          }
          $(tr).removeClass('selected-row')
        }
      }
      this.$refs.table.setCurrentRow(this.currentRow)
      this.$emit('row-select', ...arguments)
    } else {
      // 从选中队列去除上一条选中的
      let index = this.currentSelectedData.indexOf(this.currentRow)
      if (index > -1) {
        this.currentSelectedData.splice(index, 1)
      }
      // 如果加入选中队列
      if (tr.className.indexOf('selected-row') < 0) {
        this.currentSelectedData.push(row)
      } else {
        // 如果本来就是已经选中的，那么取消选中样式
        $(tr).removeClass('selected-row')
      }
      // 点击变蓝色
      this.currentRow = row
      this.$emit('row-click', ...arguments)
    }
  }
  clickTd () {
    this.$emit('cell-click', ...arguments)
  }
  handleSelectionChange () {
    this.$emit('selection-change', ...arguments)
  }
  select () {
    this.$emit('select', ...arguments)
  }
  selectAll () {
    this.$emit('select-all', ...arguments)
  }
  sortChange () {
    this.$emit('sort-change', ...arguments)
  }
}
